import {
  getPricingSettings,
  setPricingSettings,
  variableDealerGetStrategy,
  variableDealerCreate,
  variableDealerUpdate,
  fixedByZipDealerGetStrategy,
  fixedByZipDealerCreate,
  fixedByZipDealerUpdateRow,
  fixedByZipDealerDeleteRow,
  pricingBandsDealerGetStrategy,
  pricingBandsDealerGetSettings,
  pricingBandsDealerSetSettings,
  pricingBandsDealerCreateRow,
  pricingBandsDealerUpdateRow,
  pricingBandsDealerDeleteRow,
  costPlusDealerGetStrategy,
  costPlusDealerCreate,
  costPlusDealerUpdate, // fixedByZipTransporterGetStrategy,
  // fixedByZipTransporterAddRow,
  // fixedByZipTransporterUpdateRow,
  // fixedByZipTransporterDeleteRow,
  residentialDealerGetStrategy,
  residentialDealerCreate,
  residentialDealerUpdate,
} from "@/services/pricingStrategies";
import {
  DealerStrategiesEnum,
  TransporterStrategiesEnum,
  PricingValueTypeEnum,
} from "@/components/Strategies/constants";

const Model = {
  namespace: "pricingStrategies",
  state: {
    strategyId: null,
    settingsConcurrencyStamp: null,
    parentReferenceId: null,
    dealerStrategyInherited: false,
    dealerStrategyType: null,
    transporterStrategyType: null,
    transporterStrategyInherited: false,
    dealerStrategy: null,
    draftDealerStrategy: null,
    transporterStrategy: null,
    draftTransporterStrategy: null,

    dealerPricingBandsSettings: null,
  },
  effects: {
    /* Dealers */
    *dealerGetStrategyVariable({ referenceId }, { call, put, select }) {
      const { parentReferenceId, dealerStrategyInherited } = yield select(state => {
        return {
          parentReferenceId: state.pricingStrategies.parentReferenceId,
          dealerStrategyInherited: state.pricingStrategies.dealerStrategyInherited,
        };
      });

      try {
        const response = yield call(
          variableDealerGetStrategy,
          dealerStrategyInherited ? parentReferenceId : referenceId,
        );

        yield put({
          type: "setDealerStrategy",
          payload: {
            ...response,
            referenceId,
            strategyType: DealerStrategiesEnum.Variable,
          },
        });

        return true;
      } catch (error) {
        return false;
      }
    },
    *dealerGetStrategyResidential({ referenceId }, { call, put, select }) {
      const { parentReferenceId, dealerStrategyInherited } = yield select(state => {
        return {
          parentReferenceId: state.pricingStrategies.parentReferenceId,
          dealerStrategyInherited: state.pricingStrategies.dealerStrategyInherited,
        };
      });

      try {
        const response = yield call(
          residentialDealerGetStrategy,
          dealerStrategyInherited ? parentReferenceId : referenceId,
        );

        yield put({
          type: "setDealerStrategy",
          payload: {
            ...response,
            referenceId,
            strategyType: DealerStrategiesEnum.Residential,
          },
        });

        return true;
      } catch (error) {
        return false;
      }
    },
    *dealerGetStrategyPricingBands({ referenceId, page, pageSize }, { call, put, select }) {
      const { parentReferenceId, dealerStrategyInherited } = yield select(state => {
        return {
          parentReferenceId: state.pricingStrategies.parentReferenceId,
          dealerStrategyInherited: state.pricingStrategies.dealerStrategyInherited,
        };
      });

      try {
        const response = yield call(
          pricingBandsDealerGetStrategy,
          dealerStrategyInherited ? parentReferenceId : referenceId,
          page,
          pageSize,
        );

        yield put({
          type: "setDealerStrategy",
          payload: {
            ...response,
            referenceId,
            strategyType: DealerStrategiesEnum.PricingBands,
          },
        });

        return true;
      } catch (error) {
        return false;
      }
    },
    *dealerPricingBandsGetSettings({ referenceId }, { call, put, select }) {
      const { parentReferenceId, dealerStrategyInherited } = yield select(state => {
        return {
          parentReferenceId: state.pricingStrategies.parentReferenceId,
          dealerStrategyInherited: state.pricingStrategies.dealerStrategyInherited,
        };
      });

      try {
        const response = yield call(
          pricingBandsDealerGetSettings,
          dealerStrategyInherited ? parentReferenceId : referenceId,
        );

        yield put({
          type: "setDealerPricingBandsSettings",
          payload: response,
        });

        return true;
      } catch (error) {
        return false;
      }
    },
    *dealerPricingBandsSetSettings({ id, concurrencyStamp, threshold, flatRate, pricePerMile }, { call, put }) {
      try {
        const response = yield call(
          pricingBandsDealerSetSettings,
          id,
          concurrencyStamp,
          threshold,
          flatRate,
          pricePerMile,
        );

        yield put({
          type: "setDealerPricingBandsSettings",
          payload: response,
        });

        return true;
      } catch (error) {
        return false;
      }
    },
    *dealerPricingBandsAddRow({ referenceId, distanceLower, distanceUpper, price, page, pageSize }, { call, put }) {
      try {
        const response = yield call(pricingBandsDealerCreateRow, referenceId, distanceLower, distanceUpper, price);

        if (response === undefined) {
          return false;
        }

        yield put({
          type: "pricingStrategies/dealerGetStrategyPricingBands",
          referenceId,
          page,
          pageSize,
        });

        return true;
      } catch (error) {
        return false;
      }
    },
    *dealerPricingBandsUpdateRow(
      { id, referenceId, concurrencyStamp, distanceLower, distanceUpper, price, page, pageSize },
      { call, put },
    ) {
      try {
        const response = yield call(
          pricingBandsDealerUpdateRow,
          id,
          concurrencyStamp,
          referenceId,
          distanceLower,
          distanceUpper,
          price,
        );

        if (response === undefined) {
          return false;
        }

        yield put({
          type: "pricingStrategies/dealerGetStrategyPricingBands",
          referenceId,
          page,
          pageSize,
        });

        return true;
      } catch (error) {
        return false;
      }
    },
    *dealerPricingBandsDeleteRow({ referenceId, rowId, page, pageSize }, { call, put }) {
      try {
        yield call(pricingBandsDealerDeleteRow, rowId);

        yield put({
          type: "pricingStrategies/dealerGetStrategyPricingBands",
          referenceId,
          page,
          pageSize,
        });
        return true;
      } catch (error) {
        return false;
      }
    },
    *dealerGetStrategyFixedByZip({ referenceId, page, pageSize }, { call, put, select }) {
      const { parentReferenceId, dealerStrategyInherited } = yield select(state => {
        return {
          parentReferenceId: state.pricingStrategies.parentReferenceId,
          dealerStrategyInherited: state.pricingStrategies.dealerStrategyInherited,
        };
      });

      try {
        const response = yield call(
          fixedByZipDealerGetStrategy,
          dealerStrategyInherited ? parentReferenceId : referenceId,
          page,
          pageSize,
        );

        yield put({
          type: "setDealerStrategy",
          payload: {
            ...response,
            referenceId,
            strategyType: DealerStrategiesEnum.FixedByZip,
          },
        });

        return true;
      } catch (error) {
        return false;
      }
    },
    *dealerFixedByZipAddRow(
      {
        referenceId,
        zipFrom,
        zipTo,
        carPrice,
        suvPrice,
        truckPrice,
        truckHeavyPrice,
        direction,
        priceType,
        page,
        pageSize,
      },
      { call, put, select },
    ) {
      const { dealerStrategyInherited, parentReferenceId } = yield select(state => state.pricingStrategies);

      try {
        yield call(
          fixedByZipDealerCreate,
          dealerStrategyInherited ? parentReferenceId : referenceId,
          zipFrom,
          zipTo,
          carPrice,
          suvPrice,
          truckPrice,
          truckHeavyPrice,
          priceType,
          direction,
        );

        yield put({
          type: "pricingStrategies/dealerGetStrategyFixedByZip",
          referenceId,
          page,
          pageSize,
        });

        return true;
      } catch (error) {
        return false;
      }
    },
    *dealerFixedByZipUpdateRow(
      {
        referenceId,
        zipFrom,
        zipTo,
        carPrice,
        suvPrice,
        truckPrice,
        truckHeavyPrice,
        id,
        priceType,
        concurrencyStamp,
        page,
        pageSize,
      },
      { call, put },
    ) {
      try {
        yield call(
          fixedByZipDealerUpdateRow,
          zipFrom,
          zipTo,
          carPrice,
          suvPrice,
          truckPrice,
          truckHeavyPrice,
          priceType,
          id,
          concurrencyStamp,
        );

        yield put({
          type: "pricingStrategies/dealerGetStrategyFixedByZip",
          referenceId,
          page,
          pageSize,
        });

        return true;
      } catch (error) {
        return false;
      }
    },
    *dealerFixedByZipDeleteRow({ referenceId, rowId, page, pageSize }, { call, put }) {
      try {
        yield call(fixedByZipDealerDeleteRow, rowId);

        yield put({
          type: "pricingStrategies/dealerGetStrategyFixedByZip",
          referenceId,
          page,
          pageSize,
        });

        return true;
      } catch (error) {
        return false;
      }
    },
    *dealerGetStrategyCostPlus({ referenceId }, { call, put, select }) {
      const { parentReferenceId, dealerStrategyInherited } = yield select(state => {
        return {
          parentReferenceId: state.pricingStrategies.parentReferenceId,
          dealerStrategyInherited: state.pricingStrategies.dealerStrategyInherited,
        };
      });
      try {
        const response = yield call(
          costPlusDealerGetStrategy,
          dealerStrategyInherited ? parentReferenceId : referenceId,
        );

        yield put({
          type: "setDealerStrategy",
          payload: {
            ...response,
            referenceId,
            strategyType: DealerStrategiesEnum.CostPlus,
          },
        });

        return true;
      } catch (error) {
        return false;
      }
    },
    *dealerGetStrategyNissanCityToCity({ referenceId }, { put }) {
      yield put({
        type: "setDealerStrategy",
        payload: {
          referenceId,
          concurrencyStamp: null,
          strategyType: DealerStrategiesEnum.NissanCityToCity,
          id: null,
        },
      });
    },
    *dealerSetDraftStrategy({ strategy }, { put }) {
      yield put({
        type: "setDealerDraftStrategy",
        strategyType: strategy.strategyType,
        payload: strategy,
      });
    },

    /* Transporter */
    *transporterGetVariable(
      {
        referenceId,
        // , page, pageSize
      },
      {
        // call,
        put,
        // , select
      },
    ) {
      yield put({
        type: "setTransporterStrategy",
        payload: {
          referenceId,
          concurrencyStamp: null,
          strategyType: TransporterStrategiesEnum.Variable,
          id: null,
        },
      });
    },
    *transporterGetStrategyNissanCityToCity({ referenceId }, { put }) {
      yield put({
        type: "setTransporterStrategy",
        payload: {
          referenceId,
          concurrencyStamp: null,
          strategyType: TransporterStrategiesEnum.NissanCityToCity,
          id: null,
        },
      });
    },

    *transporterSetDraftStrategy({ strategy }, { put }) {
      yield put({
        type: "setTransporterDraftStrategy",
        referenceId: strategy.referenceId,
        strategyType: strategy.strategyType,
        payload: strategy,
      });
    },

    /* Both */
    *getSettings({ referenceId }, { call, put }) {
      try {
        const response = yield call(getPricingSettings, referenceId);

        yield put({
          type: "storeSettingsValues",
          payload: response,
        });

        return true;
      } catch (error) {
        return false;
      }
    },
    *setSettings({ strategyId, settingsConcurrencyStamp, dealerStrategyType, transporterStrategyType }, { call, put }) {
      try {
        const response = yield call(
          setPricingSettings,
          strategyId,
          settingsConcurrencyStamp,
          dealerStrategyType,
          transporterStrategyType,
        );

        yield put({
          type: "storeSettingsValues",
          payload: response,
        });

        return true;
      } catch (error) {
        return false;
      }
    },
    *submitStrategies({ dealerStrategy, transporterStrategy }, { call, put }) {
      let dealerResponse = null;
      let dealerError = null;
      let transporterResponse = null;
      let transporterError = null;

      const dealerIsDefault = dealerStrategy?.valueType === PricingValueTypeEnum.Default;

      if (dealerStrategy !== null) {
        switch (dealerStrategy.strategyType) {
          case DealerStrategiesEnum.Variable: {
            try {
              dealerResponse = yield call(
                dealerIsDefault ? variableDealerCreate : variableDealerUpdate,
                dealerIsDefault ? dealerStrategy.referenceId : dealerStrategy.concurrencyStamp,
                dealerStrategy.margin,
                dealerStrategy.id,
              );
            } catch (error) {
              dealerError = error;
            }

            break;
          }
          case DealerStrategiesEnum.CostPlus: {
            try {
              dealerResponse = yield call(
                dealerIsDefault ? costPlusDealerCreate : costPlusDealerUpdate,
                dealerIsDefault ? dealerStrategy.referenceId : dealerStrategy.concurrencyStamp,
                dealerStrategy.amount,
                dealerStrategy.id,
              );
            } catch (error) {
              dealerError = error;
            }
            break;
          }
          case DealerStrategiesEnum.Residential: {
            try {
              dealerResponse = yield call(
                dealerIsDefault ? residentialDealerCreate : residentialDealerUpdate,
                dealerIsDefault ? dealerStrategy.referenceId : dealerStrategy.concurrencyStamp,
                dealerStrategy.margin,
                dealerStrategy.id,
              );
            } catch (error) {
              dealerError = error;
            }

            break;
          }
        }
      }

      if (transporterStrategy !== null) {
        // I left this if block in case we implement a new transporter strategy
        // type with a "draft" status, like currently "Cost Plus" and "Variable"
        // strategies work for dealers, but by now the only strategies
        // transporters have are "Nissan City to City" (which doesn't require
        // updates) and "Pricing Bands" (which updates on every change).
      }

      if (dealerResponse !== null) {
        const payload = {
          ...dealerResponse,
          strategyType: dealerStrategy.strategyType,
          valueType: dealerResponse.type,
        };

        delete payload.type;

        yield put({
          type: "setDealerStrategy",
          payload,
        });
      }

      if (transporterResponse !== null) {
        const payload = {
          ...transporterResponse,
          strategyType: transporterStrategy.strategyType,
          valueType: transporterResponse.type,
        };

        delete payload.type;

        yield put({
          type: "setTransporterStrategy",
          payload,
        });
      }

      return {
        dealerError,
        transporterError,
      };
    },
  },
  reducers: {
    log(state, { message, payload }) {
      console.log(message, payload);
      return state;
    },
    storeSettingsValues(state, { payload }) {
      const {
        id: strategyId,
        concurrencyStamp,
        transporterStrategy,
        shipperStrategy,
        isShipperOverwritten,
        isTransporterOverwritten,
        parentReferenceId,
      } = payload;

      return {
        ...state,
        strategyId,
        settingsConcurrencyStamp: concurrencyStamp,
        parentReferenceId,
        dealerStrategyType: shipperStrategy,
        dealerStrategyInherited: !isShipperOverwritten && parentReferenceId !== null,
        transporterStrategyType: transporterStrategy,
        transporterStrategyInherited: !isTransporterOverwritten && parentReferenceId !== null,
      };
    },
    setDealerStrategy(state, { payload }) {
      const newStrategy = {
        ...payload,
        valueType: payload?.type,
      };

      delete newStrategy.type;

      return {
        ...state,
        dealerStrategy: newStrategy,
        draftDealerStrategy: newStrategy,
      };
    },
    setDealerPricingBandsSettings(state, { payload }) {
      return {
        ...state,
        dealerPricingBandsSettings: {
          id: payload.id,
          concurrencyStamp: payload.concurrencyStamp,
          threshold: payload.threshold,
          flatRate: payload.flatRate,
          pricePerMile: payload.pricePerMile,
        },
      };
    },
    setTransporterStrategy(state, { payload }) {
      const newStrategy = {
        ...payload,
        valueType: payload?.type,
      };

      delete newStrategy.type;

      return {
        ...state,
        transporterStrategy: newStrategy,
        draftTransporterStrategy: newStrategy,
      };
    },
    setDealerDraftStrategy(state, { strategyType, payload }) {
      const draftDealerStrategy = {
        strategyType,
        concurrencyStamp: payload?.concurrencyStamp,
        id: payload?.id,
        referenceId: payload?.referenceId,
        valueType: payload?.valueType,
      };

      switch (payload.strategyType) {
        case DealerStrategiesEnum.Variable:
          draftDealerStrategy.margin = payload.margin;
          break;

        case DealerStrategiesEnum.Residential:
          draftDealerStrategy.margin = payload.margin;
          break;

        case DealerStrategiesEnum.CostPlus:
          draftDealerStrategy.amount = payload.amount;
          break;
      }

      return {
        ...state,
        draftDealerStrategy,
      };
    },
    setTransporterDraftStrategy(state, { payload }) {
      const transporterDraftStrategy = {
        concurrencyStamp: payload.concurrencyStamp,
        id: payload.id,
        referenceId: payload.referenceId,
        strategyType: payload.strategyType,
      };

      return {
        ...state,
        transporterDraftStrategy,
      };
    },
    discardDealerDraftStrategy(state) {
      return {
        ...state,
        draftDealerStrategy: state.dealerStrategy,
        draftTransporterStrategy: state.transporterStrategy,
      };
    },
    discardDraftTransporterStrategy(state) {
      return {
        ...state,
        draftDealerStrategy: state.dealerStrategy,
        draftTransporterStrategy: state.transporterStrategy,
      };
    },
  },
};

export default Model;
